<template>
  <div>
    <div class="page">
      <div class="page-bg details-img">
        <div class="img-header">
          <div
            class="collection-btn"
            @click="setCollectionBtn"
            :class="details.is_collection === 1 ? 'acitve' : ''"
          >
            <div class="icon"></div>
            <div class="text">
              {{
                details.is_collection === 1
                  ? details.collection_num
                  : details.collection_num
              }}
            </div>
          </div>
          <div class="share-btn" @click="shareBtn">
            <div class="icon"></div>
          </div>
        </div>
        <div class="img-wrap">
          <div class="img">
            <div class="swiper-banner-container" ref="swiper-banner-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="animate" v-if="details.image_url.length > 1" >
                    <img :src="item" v-for="(item,index) in details.image_url" :key="index" alt="" />
                  </div>
                  <div class="pic" v-else><img :src="details.image_url" alt="" /></div>
                </div>
                <div class="swiper-slide" v-if="details.videos">
                  <div class="video">
                    <video 
                      muted
                      loop
                      preload="auto" 
                      autoplay="autoplay" 
                      x5-playsinline="true" 
                      playsinline="true" 
                      webkit-playsinline="true" 
                      x-webkit-airplay="true" 
                      x5-video-player-type="h5" 
                      x5-video-player-fullscreen="true" 
                      x5-video-orientation="portraint"
                    ><source :src="details.videos" type="video/mp4"></video>
                  </div>
                </div>

              </div>
              <div class="swiper-pagination" ref="swiper-banner-pagination"></div>
            </div>
            
          </div>
          <div class="info">
            <div class="title">{{ details.title }}</div>
            <div class="limit">
              <div><span>限量</span>{{ details.all_num }}份</div>
            </div>
          </div>
        </div>
      </div>
      <div class="details-info">
        <div class="info-title">
          <div class="text">
            <div class="liner">
              <div class="liner-3"></div>
              <div class="liner-2"></div>
              <div class="liner-1"></div>
            </div>
            <span class="lock">购买即可体验以下内容</span>
            <div class="liner">
              <div class="liner-1"></div>
              <div class="liner-2"></div>
              <div class="liner-3"></div>
            </div>
          </div>
        </div>
        <div class="details-info-bg equityList">
          <div
            class="item"
            v-for="(item, index) in details.experience"
            :key="index"
          >
            <div class="icon">
              <img :src="item.image_url" alt="" />
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
        </div>

        <template v-if="details.entity.length > 0">
          <div class="info-title">
            <div class="text">
              <div class="liner">
                <div class="liner-1"></div>
              </div>
              <span class="tit">可定制额外体验内容</span>
              <div class="liner">
                <div class="liner-1"></div>
              </div>
            </div>
          </div>
          <div class="details-info-bg equityList">
            <div
              class="item"
              :class="{ on: customized }"
              @click="customizedClick()"
              v-for="(item, index) in details.entity"
              :key="index"
            >
              <div class="icon">
                <img :src="item.image_url" alt="" />
              </div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </template>

        <div class="details-info-bg info-author">
          <!-- <div class="img">
              <img src="../../../assets/images/user/my/tx.png"  />
          </div> -->
          <div class="info">
            <div class="tit">创作者</div>
            <div class="name">{{ details.author }}</div>
          </div>
        </div>
        <div class="info-content" v-html="details.content"></div>
      </div>
      
      <div class="details-footer">
        <div class="price">￥{{ Number(details.price) }}</div>
        <div class="btn disabled" @click="regOrder()">
            <span>{{Number(details.status) === 1
              ? "立即购买"
              : Number(details.status) === 2
              ? "已售罄"
              : "敬请期待"}}
            </span>
        </div>
      </div>

      <GeneratePoster
        :shareInfo="shareInfo"
        ref="GeneratePoster"
      ></GeneratePoster>
    </div>
  </div>
</template>

<script>
import GeneratePoster from "../../../components/generate_poster";
import Swiper from "../../../assets/js/libs/swiper.min";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Image as VanImage, Lazyload, Toast } from "vant";

Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Toast);

export default {
  name: "goods-details",
  data() {
    return {

      isShow: false,
      isShare: false,
      equityList: [
        {
          img: require("../../../assets/images/home/details/tx.png"),
          title: "生产头像",
        },
        {
          img: require("../../../assets/images/home/details/zs.png"),
          title: "数字证书",
        },
        {
          img: require("../../../assets/images/home/details/sp.png"),
          title: "独家视频",
        },
        {
          img: require("../../../assets/images/home/details/qm.png"),
          title: "官方签名",
        },
        {
          img: require("../../../assets/images/home/details/zk.png"),
          title: "惊喜折扣",
        },
        {
          img: require("../../../assets/images/home/details/dz.png"),
          title: "定制实物",
        },
      ],
      gid: this.$route.query.id ? this.$route.query.id : "",
      shareInfo: {
        title: "",
        author: "",
        image_url: "",
        shareUrl: "",
        shareText: "",        
      },
      customized: false,

      imgUrl:[
        
      ],
      

    };
  },
  components: {
    GeneratePoster,
  },

  created() {
    let that = this;
    if (!parseInt(this.gid)) {
      Toast.fail("参数错误");
      setTimeout(() => {
        Toast.clear();
        this.$router.go(-1);
      }, 600);
      return false;
    }

    let toastLoading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "正在加载...",
    });

    this.getDetails({
      id: this.gid,
      success: (res) => {
        toastLoading.clear();

        if (res.status === 1) {
          that.isShow = true;
          that.$nextTick(async () => {
            // document.title=this.details.title;
            that.shareInfo.title = that.details.title;
            that.shareInfo.author = that.details.author;
            that.shareInfo.image_url = that.details.image_url[0];
            that.shareInfo.status = that.details.status;
            that.shareInfo.shareUrl = that.details.shareUrl;
            that.shareInfo.shareText = "微信扫一扫或<br/>长按识别二维码进入";
            let url = window.location.href;
            // console.log(url);
            that.$refs.GeneratePoster.createQrcode(url); // 方法2:直接调用

            if(that.details.videos){
              that.swiperBannerFun();
            }
            
            
          });
        } else {
          Toast.fail(res.message);
          setTimeout(() => {
            Toast.clear();
            this.$router.go(-1);
          }, 600);
        }
      },
    });
  },
  methods: {
    ...mapActions({
      getDetails: "goods/getDetails",
      setCollection: "user/setCollection",
    }),
    swiperBannerFun(){
      let that = this;    
      that.swiperBanner = new Swiper(this.$refs["swiper-banner-container"], {
        init: true,
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        initialSlide: 0,
        loop: false, // 循环模式选项
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true,//修改swiper父元素时，自动初始化swiper
				observeSlideChildren: true,
        resizeObserver: true,
      });
      that.$nextTick(() => {
				that.swiperBanner.update();
			})

    },

    shareBtn() {
      this.$refs.GeneratePoster.createPoster(); // 方法2:直接调用
    },

    setCollectionBtn() {
      if (!this.isLogin) {
        this.$router.push("/login");
        return false;
      }
      let type = parseInt(this.details.is_collection) === 1 ? 0 : 1;
      let toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      this.setCollection({
        id: this.gid,
        type: type,
        success: (res) => {
          toastLoading.clear();
          if (res.status == 1) {
            this.$store.commit("goods/SET_COLLECTION", { type: type });

            if (type === 1) {
              Toast.success("收藏成功");
            } else {
              Toast.success("已取消收藏");
            }
          } else {
            Toast.fail(res.message);
          }
        },
      });
    },

    customizedClick() {
      // this.customized = !this.customized;
    },
    regOrder() {

      // Toast('敬请期待');
      
      return false;

      if (!this.isLogin) {
        this.$router.push("/login");
        return false;
      }
      this.$router.push("/goods/order");
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.goods.details,
      isLogin: (state) => state.user.isLogin,
    }),
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>

@import "../../../assets/css/common/swiper.min.css";

@keyframes xz1 {
  0%{
    transform: rotateY(0deg);
  }
  50%{
    transform: rotateY(180deg);
  }
  100%{
    transform: rotateY(0deg);
  }
}

@keyframes xz2 {
  0%{
    transform: rotateY(-180deg);
  }  
  50%{
    transform: rotateY(0);
  }   
  100%{
    transform: rotateY(-180deg);
  }
}

.page {
  background: #efeeec;
  min-height: 100vh;
  padding-bottom: 1.24rem;
}
.swiper-banner-container {
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
  }
}
.details-img {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  // padding: 0 0.6rem;

  .img-header {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1.05rem 0.94rem 0 0.6rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    z-index: 3;

    .collection-btn {
      color: #282727;
      display: flex;
      align-items: center;
      line-height: 1;
      .icon {
        background: url("../../../assets/images/home/goods/ic-collection.png")
          no-repeat center;
        background-size: 100%;
        width: 0.47rem;
        height: 0.47rem;
      }
      .text {
        font-size: 0.41rem;
        margin-left: 0.2rem;
        flex: 1;
        line-height: 1.2;
      }
    }
    .share-btn {
      .icon {
        background: url("../../../assets/images/common/ic-share.png") no-repeat
          center;
        background-size: 100%;
        width: 0.5rem;
        height: 0.43rem;
      }
    }
  }
  .img-wrap {
    width: 100%;
    height: 7.26rem;
    box-sizing: border-box;
    background: url("../../../assets/images/home/details/img-b.png") no-repeat
      bottom center;
    background-size: 84% auto;
    // padding-top: 0.45rem;
    .img {
      text-align: center;
      height: 5.07rem;
      margin: 0 auto;
      overflow: hidden;
      
      .pic {
        position: relative;
        height: 5.07rem;        
        width: 80%;
        margin: 0.45rem auto 0;
      }
      .animate {
        position: relative;
        height: 5.07rem;
        width: 80%;
        margin: 0.45rem auto 0;
        img {          
          position: absolute;
          top: 0;
          left: 0;
          backface-visibility: hidden;
          transition: all 1s;
          &:nth-of-type(2){
            transform: rotateY(-180deg);
          }
        }              
        img:nth-of-type(1){
          animation: xz1 12s ease-in-out 1s infinite;
        }        
        img:nth-of-type(2){
          animation: xz2 12s ease-in-out 1s infinite;
        }
      }
      .video {
        width: 80%;
        margin: 0 auto;
        height: 5.07rem;
        display: flex;
        align-items: center;
        justify-items: center;
        margin: 0.45rem auto 0;
        video {
          width: 100%;
          height: 100%;
        }
      }

    }
    .info {
      width: 100%;
      left: 0;
      bottom: 0;
      position: absolute;
      // margin-top: 0.4rem;
      height: 1.37rem;
      text-align: center;
      box-sizing: border-box;
      padding-top: 0.25rem;
      z-index: 9;
      .title {
        font-size: 0.48rem;
        color: #ffffff;
        line-height: 1;
        font-weight: bold;
      }
      .limit {
        text-align: center;
        margin-top: 0.1rem;
        div {
          display: inline-flex;
          height: 0.28rem;
          align-items: center;

          background: #5e5b5b;
          border-radius: 0.02rem;
          overflow: hidden;
          font-size: 0.2rem;
          padding-right: 0.08rem;
          color: #f8ddac;
          span {
            background: #f8ddac;
            border-radius: 0.02rem;
            display: inline-block;
            padding: 0 0.09rem;
            margin-right: 0.07rem;
            color: #280d03;
          }
        }
      }
    }
  }
}

.details-info-bg {
  background: linear-gradient(left, #e4e4e3, #c5c4c2);
  display: flex;
  align-items: center;
  padding: 0.1rem 0.8rem;
  min-height: 1rem;
}
.details-info {
  padding-bottom: 0.55rem;
  .info-title {
    text-align: center;
    padding: 0.3rem 0;
    .text {
      color: #323131;
      font-size: 0.2rem;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .liner {
        display: flex;
        align-items: center;
        justify-content: center;
        div {
          height: 2px;
          background: #505050;
          margin: 0 0.015rem;
        }
        .liner-1 {
          width: 0.87rem;
        }
        .liner-2 {
          width: 0.3rem;
        }
        .liner-3 {
          width: 0.14rem;
        }
      }
      span {
        margin: 0 0.18rem;

        &.lock {
          background: url("../../../assets/images/home/details/ic-lock.png")
            no-repeat left center;
          background-size: 0.15rem auto;
          padding-left: 0.2rem;
        }
        &.tit {
          margin: 0 0.25rem;
        }
      }
    }
  }
  .equityList {
    .item {
      text-align: center;
      line-height: 1;
      margin-right: 0.34rem;
      &:last-child {
        margin-right: 0;
      }
      &.on {
        .title {
          color: #f00;
        }
      }
      .icon {
        img {
          height: 0.5rem;
        }
      }
      .title {
        color: #323131;
        font-size: 0.2rem;
        margin-top: 0.1rem;
      }
    }
  }

  .info-author {
    margin-top: 0.5rem;
    .img {
      width: 0.75rem;
      height: 0.75rem;
      border: 1px solid #ffffff;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 0.26rem;
      img {
        width: 100%;
      }
    }
    .info {
      line-height: 1.2;
      .tit {
        font-size: 0.22rem;
        color: #646462;
      }
      .name {
        font-size: 0.24rem;
        color: #323131;
        margin-top: 0.1rem;
      }
    }
  }

  .info-content {
    color: #323131;
    font-size: 0.28rem;
    line-height: 1.6;
    padding: 0.55rem 0.55rem 0;
    img {
      max-width: 100%;
      height: auto !important;
    }
  }
}

.details-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.24rem;
  background: linear-gradient(left, #373536, #201e1f);
  padding: 0 0.55rem;
  box-sizing: border-box;
  line-height: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .price {
    font-size: 0.7rem;
    color: #f8ddac;
    font-weight: bold;
  }
  .btn {
    span {
      display: block;
      width: 2.33rem;
      height: 0.69rem;
      text-align: center;
      line-height: 0.69rem;
      font-size: 0.45rem;
      color: #fff9ed;
      text-shadow: -1.5px 0px 1.5px #915f05, 1.5px 0px 1.5px #915f05,
        0px -1.5px 1.5px #915f05, 0px 1.5px 1.5px #915f05;
      background: linear-gradient(top, #f7e0b5, #efbe66);
      border-radius: 0.1rem;
    }

    &.disabled {
      span{
        background: #f5f7fa;
        color: #c0c4cc;
        cursor: not-allowed;
        text-shadow:none;

      }
    }
  }
}
</style>

